import { FC } from 'react';
import { CONNECTION_SUCCESS_MESSAGE } from 'constants/index';

const ConnectionSuccess: FC = () => {
  window.opener && window.opener.postMessage(CONNECTION_SUCCESS_MESSAGE, '*');
  window.close();
  return null;
};

export default ConnectionSuccess;
